import { render } from "./RecommendationStep.vue?vue&type=template&id=9aeec3ac&scoped=true&ts=true"
import script from "./RecommendationStep.vue?vue&type=script&lang=ts"
export * from "./RecommendationStep.vue?vue&type=script&lang=ts"

import "./RecommendationStep.vue?vue&type=style&index=0&id=9aeec3ac&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aeec3ac"]])

export default __exports__